/* Core & libraries */
import React, {useEffect, useState} from "react";
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useAsAdminService } from "../../services/asAdminService";

/* Components */
import UCButton from "../../components/buttons";
import asLogo from "../../resources/images/as-logo.svg";

/* Styles */
import styles from "./styles.js";

const AlaskaAdminLoginPage = () => {
  const theme = useTheme();
  const classes = styles({ theme });
    const { getAdminLoginUrls } = useAsAdminService();

  const [loginUrl, setLoginUrl] = useState(null);

  useEffect(() => {
    const fetchLoginUrl = async () => {
      const data = await getAdminLoginUrls();
      if (data?.providerAdminLoginUrl) {
        setLoginUrl(data.providerAdminLoginUrl);
      }
    };

    fetchLoginUrl();
  }, [getAdminLoginUrls]);

  const handleSignIn = () => {
    if (loginUrl) {
      window.location.href = loginUrl;
    }
  };

  return (
    <div className={classes.signInContainer}>
      <div className={classes.signInContent}>
        <img src={asLogo} alt="Alaska Airlines Logo" className={classes.logo} />
        <h1 className={classes.signInTitle}><FormattedMessage id="as.admin.signInTitle" /></h1>
        <p className={classes.signInSubtitle}>
          <FormattedMessage id="as.admin.signInDescription" />
        </p>
        <UCButton
          type="primary"
          className={classes.signInButton}
          onClick={handleSignIn}
          text={<FormattedMessage id="as.admin.signInButtonText" />}
        />
      </div>
    </div>
  );
};

export default AlaskaAdminLoginPage;